import { createContext, useContext } from "react";

const ZIndexBoundaryContext = createContext<undefined | number>(undefined);

export const useClosestZIndex = (): undefined | number => useContext(ZIndexBoundaryContext);

export const ZIndexBoundaryProvider = ZIndexBoundaryContext.Provider;
